import React from "react"

function CopyToClipboard({value, children}) {

  // click
  const onClick = (e) => {
    e.preventDefault()

    const el = document.createElement('textarea')
    el.value = value
    el.setAttribute('readonly', '')
    el.style.position = 'absolute'
    el.style.left = '-9999px'
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
  }

  // render
  return (
    <div>
      <a href="#" onClick={onClick}>{children}</a>
    </div>
  )

}

export default CopyToClipboard